import React from 'react';
import styled from 'styled-components';
import AudienceCard from './AudienceCard';
import { AudienceListingProps } from './AudienceListing.types';
import { EmptyAudiences } from '@/components/icon/icons';

const AudienceListingStyled = styled.div`
  overflow-y: auto;
  ul {
    margin: 0;
    padding-inline: 0;
    list-style: none;
  }
`;

const EmptyAudienceListingStyled = styled.div`
  overflow-y: auto;
  /* position: relative;
  top: 50%;
  transform: translateY(-50%); */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 1.5em 1em;
  /* margin: auto 0; */
  text-align: center;
  /* min-height: 25em; */
  .empty-note__title {
    font-weight: 700;
    font-size: 1em;
    line-height: 1.5em;
    color: var(--color-neutral-60);
    margin: 0.25em 0 0 0;
  }
  .empty-note__text {
    margin: 0.5em 0 0 0;
    font-weight: 400;
    font-size: 1em;
    line-height: 1.5em;
    color: var(--color-neutral-60);
  }
  svg {
    min-height: 100px;
  }
`;

const AudienceListing = ({
  audiences,
  isPreview,
  removeAudience,
  toggleAudience,
}: AudienceListingProps) => {
  if (audiences.length === 0)
    return (
      <EmptyAudienceListingStyled>
        <EmptyAudiences />
        <h1 className="empty-note__title">Choose an audience to begin</h1>
        <p className="empty-note__text">
          Add one or more audiences, to preview and test your webpage content
          and interactions from any audience perspective.
        </p>
      </EmptyAudienceListingStyled>
    );
  return (
    <AudienceListingStyled>
      <ul>
        {audiences.map((audience, i) => (
          <li key={audience.id + i}>
            <AudienceCard
              audience={audience}
              isActive={!!audience.isActive}
              isDisabled={!!audience.isDisabled}
              isPreview={isPreview}
              toggleAudience={toggleAudience}
              removeAudience={removeAudience}
            />
          </li>
        ))}
      </ul>
    </AudienceListingStyled>
  );
};

export default AudienceListing;
